import styled from 'styled-components';

/**
 * An element styled to look like a regular <a> element
 */

export default styled.span`
  margin: 0;
  padding: 0;
  background-color: rgba(0, 0, 0, 0);
  border: none;
  cursor: pointer;
  text-decoration: underline;
  color: ${props => props.theme.colors.primary};

  &:hover {
    color: #ea1954;
  }
`;
